import { useCallback } from 'react';
import { linkFileToDownload } from './linkFileToDownload.ts';

interface IParams {
  data: any;
  filename?: string;
  mimetype?: string;
  /**
   * Indica se aprire il file in una nuova finestra, al posto di scaricarlo.
   */
  openInNewWindow?: boolean;
}

/**
 * Hook che restituisce una funzione per scaricare un file in locale
 * dai dati ritornati dalle API.
 */
export function useFileLocalDownload() {
  const handleDownloadFile = useCallback((params: IParams) => {
    const { data, filename, mimetype, openInNewWindow } = params;

    const fileMimeType = mimetype ?? 'application/octet-stream';

    const fileBlobUrl = URL.createObjectURL(
      new Blob([data], { type: fileMimeType }),
    );

    // biome-ignore format: <tbd>
    // console.log(`Download file: ${filename ?? ''}`, { fileMimeType, filename, openInNewWindow});

    linkFileToDownload({
      fileBlobUrl,
      filename,
      mimetype,
      openInNewWindow,
    });

    return () => URL.revokeObjectURL(fileBlobUrl);
  }, []);

  return handleDownloadFile;
}
